import React, { useState, useEffect } from "react";
import { Container, Form, Row, Table, Col, Image } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import Filter from "../offers/Filter";
import TableHead, { TableBody } from "./TableHead";
import { MenuItem, Menu } from "@material-ui/core";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import Media from "react-media";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { IconButton, InputBase, Paper } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import TableHeadEvents, { TableBodyEvents } from "./TableHeadEvents";
import TableHeadScan, { TableBodyScan } from "./TableHeadScan";
import BasicPagination from "../../Pagination/Pagination";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  PaymentActivityOrderReport,
  PaymentActivityScanReport,
  PaymentActivityEventReport,
} from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import {
  EXP_TYPE,
  ORDER_STATUS,
  ORDER_TYPE,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
  NEW_PAYMENT_TYPE,
} from "../../../enums/OrderEnums";
import moment from "moment";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import OrderViewModal from "../../reusableComponents/OrderViewModal";
import SelectFilter from "../../reusableComponents/selectFilter";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";

// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import NoContent from "../../reusableComponents/NoContentComponent";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations
function PaymentActivityReports(props) {
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="super-admin-inside-right-side-panel">
              <PaymentActivity
                PaymentActivityOrderReport={props.PaymentActivityOrderReport}
                PaymentActivityEventReport={props.PaymentActivityEventReport}
                PaymentActivityScanReport={props.PaymentActivityScanReport}
                auth={props.auth}
                paymentOrder={props?.paymentOrder || []}
                paymentEvent={props?.paymentEvent || []}
                paymentScan={props?.paymentScan || []}
              />
            </div>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
}

PaymentActivityReports.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  paymentOrder: PropTypes.array.isRequired,
  paymentEvent: PropTypes.array.isRequired,
  paymentScan: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  paymentOrder: state.reports.payment_order,
  paymentEvent: state.reports.payment_event,
  paymentScan: state.reports.payment_scan,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  PaymentActivityOrderReport,
  PaymentActivityEventReport,
  PaymentActivityScanReport,
})(PaymentActivityReports);

// export default PaymentActivityReports;

export const PaymentActivity = (props) => {
  const [stateToggle, setStateToggle] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [state, setState] = useState({
    search: "",
  });

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});

  const [showSearch, setshowSearch] = useState(false);
  const [dateQuery, setDateQuery] = useState({
    startDate: moment(new Date()).format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  });

  const handleView = (data) => {
    setShowOrderDetail(true);
    setOrderDetail(data);
  };

  const showView = () => {
    setShowOrderDetail(false);
    setOrderDetail({});
  };

  useEffect(() => {
    props.PaymentActivityOrderReport(
      props?.auth?.user?.accessToken,
      "0",
      dateQuery.startDate,
      dateQuery.endDate
    );
    props.PaymentActivityEventReport(
      props?.auth?.user?.accessToken,
      "1",
      dateQuery.startDate,
      dateQuery.endDate
    );
    props.PaymentActivityScanReport(
      props?.auth?.user?.accessToken,
      "2",
      dateQuery.startDate,
      dateQuery.endDate
    );
  }, [dateQuery]);

  let tempdata =
    (props?.paymentOrder?.length > 0 &&
      props?.paymentOrder?.filter((data) => {
        return data?.user_id?.first_name
          ?.toLowerCase()
          .includes(state.search.toLowerCase());
      })) ||
    []; //
  let Eventdata =
    (props?.paymentEvent?.length > 0 &&
      props?.paymentEvent?.filter((item) => {
        return item?.user_id?.first_name
          ?.toLowerCase()
          .includes(state.search.toLowerCase());
      })) ||
    [];
  let Scandata =
    (props?.paymentScan?.length > 0 &&
      props?.paymentScan?.filter((row) => {
        return row?.restaurant_id?.point_of_contact?.length > 0
          ? row?.restaurant_id?.point_of_contact[0]?.firstName
            ?.toLowerCase()
            .includes(state.search.toLowerCase())
          : row;
      })) ||
    [];

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    // getReportData("", data);
  };
  // console.log(props.paymentOrder);
  // if(stateToggle === 0){
  //     let tempdata = props?.paymentOrder && props?.paymentOrder.filter((data) =>{
  //       return(
  //         data?.user_id?.first_name.toLowerCase().includes(state.search.toLowerCase())
  //       )
  //   });
  // }else
  // if(stateToggle === 1){
  //   let Eventdata = props?.paymentEvent && props?.paymentEvent.filter((data) =>{
  //     return(
  //       data?.user_id?.first_name.toLowerCase().includes(state.search.toLowerCase())
  //     )
  // });
  // }else{
  //   let Scandata = props?.paymentScan && props?.paymentScan.filter((data) =>{
  //     return(
  //       data?.user_id?.first_name.toLowerCase().includes(state.search.toLowerCase())
  //     )
  // });
  // }
  let renderData = [];
  if (stateToggle === 0) renderData = tempdata;
  else if (stateToggle === 1) renderData = Eventdata;
  else if (stateToggle === 2) renderData = Scandata;
  const [filters, setFilters] = useState({
    payment_status: "",
    order_type: "",
    order_status: "",
    payment_type: "",
  });
  useState(() => {
    setFilters({
      payment_status: "",
      order_type: "",
      order_status: "",
    });
  }, [stateToggle]);

  if (filters?.payment_status === 0 || filters?.payment_status) {
    if (stateToggle === 0 || stateToggle === 2) {
      renderData = renderData.filter((data) => {
        if (filters?.payment_status === "captured")
          return data?.status === "captured";
        else return data?.status !== "captured";
      });
    } else {
      renderData = renderData.filter((data) => {
        return (
          data?.expRequestId?.paymentStatus === filters?.payment_status
        );
      });
    }
  }

  if (filters?.payment_type === 0 || filters?.payment_type) {
    if (stateToggle === 0) {
      renderData = renderData.filter(
        (data) => data?.payment_method === filters?.payment_type
      );
    } else if (stateToggle === 1) {
      renderData = renderData.filter((data) => {
        return data?.payment_method === filters?.payment_type;
      });
    }
  }

  if (filters?.order_type || filters?.order_type === 0) {
    if (stateToggle === 0) {
      renderData = renderData.filter(
        (data) => data?.order_type === filters?.order_type
      );
    } else if (stateToggle === 1) {
      let fil = { 'CURATED': 0, 'SPECIAL': 1 }
      renderData = renderData.filter(
        (data) => fil[data?.expRequestId?.expType] === filters?.order_type
      );
    }
  }

  if (
    (filters?.order_status || filters?.order_status === 0) &&
    stateToggle === 0
  ) {
    renderData = renderData.filter(
      (data) => data?.orderId?.order_status === filters?.order_status
    );
  }

  const renderOrderAccordian = () => {
    if (renderData?.length) {
      return renderData?.slice(start, end).map((item, index) => {
        return (
          <TableBodyMobile data={item} index={index} handleView={handleView} />
        );
      })
    } else {
      return <NoContent />
    }
  };

  const renderEventsAccordian = () => {
    if (renderData?.length) {
      return renderData?.slice(start, end).map((item, index) => {
        return <TableBodyMobileEvents data={item} index={index} />;
      });
    } else {
      return <NoContent />
    }
  };

  const renderScanAccordian = () => {
    if (renderData?.length) {
      return renderData?.slice(start, end).map((item, index) => {
        return <TableBodyMobile data={item} index={index} scan={true} />;
      });
    } else {
      return <NoContent />
    }
  };

  const resetFilter = (e) => {
    setFilters({
      payment_status: "",
      order_type: "",
      order_status: "",
    });
    setShowFilter(false);
  };

  /*****************************************
   * @DESC Download Button Action
   ****************************************/
  const downloadData = {
    headers: [
      { label: "Transaction Id", key: "transactionId" },
      { label: "Business Name/Location", key: "businessname" },
      { label: "User Name", key: "userName" },
      { label: "Payment Method/Payment Status", key: "paymentmethod" },
      { label: "Order Type/Order ID", key: "ordertype" },
      { label: "No.Of Items", key: "noOfItems" },
      { label: "Order Status", key: "orderstatus" },
      { label: "Date & Time", key: "date_time" },
      { label: "Amount", key: "amount" },
    ],
    data: renderData.map((ele) => {
      return {
        transactionId: ele?._id,
        businessname: `${ele?.restaurant_id?.restaurant_name} -${ele?.restaurant_id?.area}`,
        userName: `${ele?.user_id?.first_name} ${ele?.user_id?.last_name}`,
        paymentmethod: `${ele?.payment_method} ${ele?.status === "captured" ? "Success" : "Pending"
          }`,
        ordertype: `${ORDER_TYPE[ele?.orderId?.order_type]} ${ele?.order_id}`,
        noOfItems: ele?.orderId?.order_items?.length,
        orderstatus: ORDER_STATUS[ele?.orderId?.order_status],
        date_time: `${moment(ele?.createdAt).format("ll")} -  ${moment(
          ele?.createdAt
        ).format("hh:mm A")}`,
        amount: ele?.amount.toFixed(2),
      };
    }),
  };

  return (
    <Container fluid>
      <div
        className={`super-admin-inside-right-side-panel ${props?.admin && `p-0`
          }`}
      >
        <div className="seating_dashboard_top_new_header">
          <div className="row">
            <div
              className="col-12 col-md-69999 t
            
            "
            >
              <h4>Payment Activity Reports</h4>
            </div>
          </div>
        </div>
        {!props?.admin && (
          <>
            <br />
            <Row>
              <div className="col-4 ">
                <div className="d-flex align-items-center">
                  <div className="f10-400" align="center">
                    <Image
                      onClick={() => setshowSearch(!showSearch)}
                      alt="Search"
                      title="Search"
                      width="80px"
                      src={require("../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                  </div>
                  <div
                    className="filter-button"
                    onClick={() => {
                      setShowFilter(!showFilter);
                    }}
                  >
                    {/* <Filter /> */}
                    <Image
                      alt="filter"
                      title="filter"
                      width="80px"
                      src={require("../../../assets/images/seatingImages/filter.svg")}
                    />
                  </div>
                  <div className="f10-400" align="center">
                    <CSVDownloader
                      filename={
                        stateToggle === 0
                          ? "orders Payment Activity Reports"
                          : stateToggle === 1
                            ? "Experience Payment Activity Reports"
                            : "Scan & pay Payment Activity Reports"
                      }
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </div>
              </div>
              <div className="col-5"></div>
              <div className="col-3 d-flex justify-content-end">
                <SelectFilter onDateChange={onDateChangeHandler()} />
              </div>
              {/* <div className="filter-button-search">
                  <Paper component="form" className="enSearch2 d-flex">
                    <IconButton type="submit" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      placeholder="Search"
                      name="search"
                      inputProps={{
                        "aria-label": "Search by Name or Phone Number",
                      }}
                      onChange={onSearchChange}
                      value={state.search}
                    />
                  </Paper>
                </div> */}
            </Row>
          </>
        )}
        {showSearch && (
          <div className="mb-3">
            <ZoomDiv>
              <>
                <br />
                <div className="filter-button-search">
                  <Paper component="form" className="enSearch2 d-flex">
                    <IconButton type="submit" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      placeholder="Search"
                      name="search"
                      inputProps={{
                        "aria-label": "Search by Name or Phone Number",
                      }}
                      onChange={onSearchChange}
                      value={state.search}
                    />
                  </Paper>
                </div>
              </>
            </ZoomDiv>
          </div>
        )}
        {showFilter && (
          <div
            className="container-fluid p-4"
            style={{ backgroundColor: "#ffffff" }}
          >
            <Row>
              {(stateToggle === 0 || stateToggle === 1) && (
                <Col md={6}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Status">
                        {stateToggle === 0 ? "Order" : "Experience"} Type
                      </InputLabel>
                      <Select
                        value={filters?.order_type}
                        onChange={(e) =>
                          setFilters({ ...filters, order_type: e.target.value })
                        }
                        label="Order Type"
                        inputProps={{
                          name: "Order Type",
                          id: "outlined-Status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={""}>All</option>
                        {stateToggle === 0 &&
                          ORDER_TYPE.map((data, index) => (
                            <option value={index}>{data}</option>
                          ))}
                        {stateToggle === 1 &&
                          EXP_TYPE.map((data, index) => (
                            <option value={index}>{data}</option>
                          ))}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
              )}
              {stateToggle === 0 && (
                <Col md={6}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Status">
                        Order Status
                      </InputLabel>
                      <Select
                        value={filters?.order_status}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            order_status: e.target.value,
                          })
                        }
                        label="Status"
                        inputProps={{
                          name: "Status",
                          id: "outlined-Status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={""}>All</option>
                        {ORDER_STATUS.map((data, index) => (
                          <option value={index}>{data}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
              )}
              {(stateToggle === 0 || stateToggle === 1) && (
                <Col md={6}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Status">
                        Payment Method
                      </InputLabel>
                      <Select
                        value={filters?.payment_type}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            payment_type: e.target.value,
                          })
                        }
                        label="Select Payment Method"
                        inputProps={{
                          name: "Select Payment Method",
                          id: "outlined-Status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={""}>All</option>
                        {PAYMENT_TYPE.map((data) => (
                          <option value={data}>{data}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
              )}
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-Status">
                      Payment Status
                    </InputLabel>
                    <Select
                      value={filters?.payment_status}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          payment_status: e.target.value,
                        })
                      }
                      label="Select Payment Method"
                      inputProps={{
                        name: "Select Payment Method",
                        id: "outlined-Status",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={""}>All</option>
                      {stateToggle === 1
                        ? PAYMENT_STATUS.map((data, index) => (
                          <option value={index}>{data}</option>
                        ))
                        : [
                          {
                            title: "Success",
                            value: "captured",
                            applicable: [0, 2],
                          },
                          {
                            title: "Failed",
                            value: "uncaptured",
                            applicable: [0, 2],
                          },
                          {
                            title: "Pay later",
                            value: "inprogress",
                            applicable: [0],
                          },
                        ].map((data) => {
                          if (data.applicable.includes(stateToggle))
                            return (
                              <option value={data?.value}>
                                {data?.title}
                              </option>
                            );
                        })}
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
            <div class="mt-5 d-flex">
              <button
                type="button"
                onClick={() => setShowFilter(false)}
                class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                title="Cancel Button"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => setShowFilter(false)}
                class="onboarding_button_link_reusable onboarding_button_link_reusable_red  mr-3"
                title="Submit Button"
              >
                Search
              </button>
              <button
                type="button"
                onClick={(e) => resetFilter(e)}
                class="onboarding_button_link_reusable onboarding_button_link_reusable_white "
                title="Reset Button"
              >
                Reset
              </button>
            </div>
          </div>
        )}
        <div className="d-flex  mt-3">
          <div
            className={`mr-4 px-0 text-grayLink f12-500 btn btn-link  ${stateToggle === 0 && "active"
              }`}
            onClick={() => {
              setStateToggle(0);
            }}
          >
            Orders
          </div>
          <div
            className={`mr-4 px-0 text-grayLink f12-500 btn btn-link  ${stateToggle === 1 && "active"
              }`}
            onClick={() => {
              setStateToggle(1);
            }}
          >
            Experience
          </div>
          <div
            className={`mr-4 px-0 text-grayLink f12-500 btn btn-link  ${stateToggle === 2 && "active"
              }`}
            onClick={() => {
              setStateToggle(2);
            }}
          >
            Scan and Pay
          </div>
        </div>
        {stateToggle === 0 && (
          <>
            <Media query="(max-width: 991px)">
              <>
                <div className="row seating-dashboard-table">
                  <div className="col-3 p-0">
                    <p className="f12-700 pl-3">
                      Transaction <br />
                      Id
                    </p>
                  </div>
                  <div className="col-3 mpl-1 mpr-1">
                    <p className="f12-700">User Name</p>
                  </div>
                  <div className="col-3 mpl-1 pr-0">
                    <p className="f12-700">
                      Payment Method/
                      <br />
                      Payment Status
                    </p>
                  </div>
                  <div className="col-3 mpl-1">
                    <p className="f12-700">Amount</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-0">
                    <Accordion>{renderOrderAccordian()}</Accordion>
                  </div>
                </div>
              </>
            </Media>
            <Media query="(min-width: 991px)">
              <div className="col-12 p-0  user-table-reusable-superadmin ">
                <Table>
                  <thead>
                    <TableHead />
                  </thead>
                  <TableBody
                    paymentOrder={renderData}
                    auth={props.auth}
                    start={start}
                    end={end}
                    handleView={handleView}
                  />
                </Table>
              </div>
            </Media>
          </>
        )}
        {stateToggle === 1 && (
          <>
            <Media query="(max-width: 991px)">
              <>
                <div className="row seating-dashboard-table">
                  <div className="col-3 p-0">
                    <p className="f12-700 pl-3">
                      Transaction <br />
                      Id
                    </p>
                  </div>
                  <div className="col-3 mpl-1 mpr-1">
                    <p className="f12-700">User Name</p>
                  </div>
                  <div className="col-3 mpl-1 pr-0">
                    <p className="f12-700">
                      Payment Method/
                      <br />
                      Payment Status
                    </p>
                  </div>
                  <div className="col-3 mpl-1">
                    <p className="f12-700">Amount</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-0">
                    <Accordion>{renderEventsAccordian()}</Accordion>
                  </div>
                </div>
              </>
            </Media>
            <Media query="(min-width: 991px)">
              <div className="col-12 p-0  user-table-reusable-superadmin ">
                <Table>
                  <thead>
                    <TableHeadEvents />
                  </thead>
                  <TableBodyEvents
                    paymentOrder={renderData}
                    auth={props.auth}
                    start={start}
                    end={end}
                  />
                </Table>
              </div>
            </Media>
          </>
        )}

        {stateToggle === 2 && (
          <>
            <Media query="(max-width: 991px)">
              <>
                <div className="row seating-dashboard-table">
                  <div className="col-3 p-0">
                    <p className="f12-700 pl-3">
                      Transaction <br />
                      Id
                    </p>
                  </div>
                  <div className="col-3 mpl-1 mpr-1">
                    <p className="f12-700">User Name</p>
                  </div>
                  <div className="col-3 mpl-1 pr-0">
                    <p className="f12-700">
                      Payment Method/
                      <br />
                      Payment Status
                    </p>
                  </div>
                  <div className="col-3 mpl-1">
                    <p className="f12-700">Amount</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-0">
                    <Accordion>{renderScanAccordian()}</Accordion>
                  </div>
                </div>
              </>
            </Media>
            <Media query="(min-width: 991px)">
              <div className="col-12 p-0  user-table-reusable-superadmin ">
                <Table>
                  <thead>
                    <TableHeadScan />
                  </thead>
                  <TableBodyScan
                    paymentOrder={renderData}
                    auth={props.auth}
                    start={start}
                    end={end}
                  />
                </Table>
              </div>
            </Media>
          </>
        )}

        {showOrderDetail && (
          <OrderViewModal orderDetails={orderDetail} handleClose={showView} />
        )}

        <BasicPagination
          totalRecords={renderData?.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      </div>
    </Container>
  );
};

const TableBodyMobile = (props) => {
  const item = props?.data || {};
  const displayAllTransactionId = (data) => {
    let transaction = data;
    let transactionArr = [];
    for (let i = 0; i < transaction.length; i++) {
      transactionArr.push(transaction[i].txnId);
    }
    return transactionArr;
  };

  return (
    <React.Fragment key={props?.index}>
      <Card className="main-reusable-accordion mt-1">
        <Accordion.Toggle as={Card.Header} eventKey={props?.index + 1}>
          <div className="d-flex align-items-center">
            <div className="card-header-left f10-500 text-break">
              {/* {item?.transactionNumber || item?._id} */}
              {item?.orderId?.splitPayment
                ? displayAllTransactionId(
                  item?.orderId?.transactionDetails
                ).map((data, index) => {
                  return (
                    <React.Fragment key={index}>
                      {data}
                      <br />
                    </React.Fragment>
                  );
                })
                : item?.transactionNumber || item?._id}
            </div>
            <div className="card-header-middle f10-500">
              {/* <div className="d-flex align-items-center"> */}
              {/* <div className="super-admin-suggestion-table-body-boxone">
                  {item?.user_id?.profile_photo[0] ? (
                    <div className="super-admin-suggestion-imageBoxOne enIMG33">
                      <Image
                        fluid
                        src={item?.user_id?.profile_photo[0]}
                        alt="Icon"
                        className="rounded-circle"
                      />
                    </div>
                  ) : (
                    <div className="super-admin-suggestion-imageBoxOne enIMG33">
                      <Image
                        fluid
                        src={require("../../../assets/images/ActionImages/demoprofile.jpg")}
                        alt="Icon"
                        className="rounded-circle"
                      />
                    </div>
                  )}
                </div> */}
              {/* <div className="super-admin-suggestion-imageBoxTwo ml-2"> */}
              <div className="f12-500">
                {item?.user_id?.first_name} {item?.user_id?.last_name}
              </div>
              {/* </div> */}
              {/* </div> */}
            </div>
            <div className="card-header-middle ml-2 f10-500">
              {props?.scan ? (
                <>
                  {item?.payment_captured ? (
                    <div
                      className="badge badge-success p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      Completed
                    </div>
                  ) : (
                    <div
                      className="badge badge-warning p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      Pending
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="f12-500 mb-2">
                    {item?.orderId?.splitPayment ? (
                      <>Split Payment</>
                    ) : (
                      NEW_PAYMENT_TYPE[item?.orderId?.payment_method]
                    )}
                    {/* {PAYMENT_TYPE[item?.orderId?.payment_method]} */}
                  </div>
                  {item?.orderId?.payment_status === 0 ? (
                    <div
                      className="badge badge-warning p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      {PAYMENT_STATUS[item?.orderId?.payment_status]}
                    </div>
                  ) : null}
                  {item?.orderId?.payment_status === 1 ? (
                    <div
                      className="badge badge-success p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      {PAYMENT_STATUS[item?.orderId?.payment_status]}
                    </div>
                  ) : null}
                  {item?.orderId?.payment_status === 2 ? (
                    <div
                      className="badge badge-danger p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      {PAYMENT_STATUS[item?.orderId?.payment_status]}
                    </div>
                  ) : null}
                  {item?.orderId?.payment_status === 3 ? (
                    <div
                      className="badge badge-danger p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      {PAYMENT_STATUS[item?.orderId?.payment_status]}
                    </div>
                  ) : null}
                  {item?.orderId?.payment_status === 4 ? (
                    <div
                      className="badge badge-info p-2"
                      style={{ borderRadius: "1rem", color: "white" }}
                    >
                      {PAYMENT_STATUS[item?.orderId?.payment_status]}
                    </div>
                  ) : null}{" "}
                </>
              )}
            </div>
            <div className="card-header-right f10-500 justify-content-center">
              <div className="f12-500">
                ₹ {item?.orderId?.total_amount.toFixed(2)}
              </div>
            </div>
          </div>{" "}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={props?.index + 1}>
          <Card.Body>
            {/******* Section One *********/}
            {!props?.scan && (
              <>
                <hr className="mt-0" />
                <div className="row">
                  <div className="col-4 sectionone-left">
                    <p className="f10-700 pb-2 opacity5">
                      Order Type/ <br />
                      Order Id
                    </p>

                    <div className="f12-400">
                      {ORDER_TYPE[item?.orderId?.order_type]}
                      <br />
                      {item?.orderId?.order_id}
                    </div>
                  </div>
                  <div className="col-4 sectionone-middle ">
                    <p className="f10-700 pb-2 opacity5">No. Items</p>
                    <div className="f10-400">
                      {item?.orderId?.order_items?.length || 0}
                    </div>
                  </div>
                  <div className="col-4 sectionone-right ">
                    <p className="f10-700 pb-2 opacity5">Order Status</p>
                    <div className="f10-400">
                      {ORDER_STATUS[item?.orderId?.order_status]}
                    </div>
                  </div>
                </div>
              </>
            )}
            {/******* Section Two *********/}
            <hr className="mt-0" />
            <div className="row">
              <div className="col-4 sectionone-left"></div>
              <div className="col-5 sectionone-middle ">
                <p className="f10-700 pb-2 opacity5">Date & Time</p>
                <div className="f10-400">
                  {moment(item?.createdAt).format("Do MMM YYYY")}
                  <br />
                  {moment(item?.createdAt).format("hh:mm A")}
                </div>
              </div>
              <div className="col-3 sectionone-right ">
                <div
                  className="f10-400 m-2"
                  align="center"
                  onClick={() => props.handleView(item.orderId)}
                >
                  <img
                    src={require("../../../assets/images/iconButton/eye.png")}
                    width="35px"
                    alt="icon"
                  />
                </div>
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </React.Fragment>
  );
};

const TableBodyMobileEvents = (props) => {
  const item = props?.data || {};
  return (
    <React.Fragment key={props?.index}>
      <Card className="main-reusable-accordion mt-1">
        <Accordion.Toggle as={Card.Header} eventKey={props?.index + 1}>
          <div className="d-flex align-items-center text-break">
            <div className="card-header-left f10-500 text-break">
              {item?.transactionNumber || item?._id}
            </div>
            <div className="card-header-middle f10-500">
              {/* <div className="d-flex align-items-center"> */}
              {/* <div className="super-admin-suggestion-table-body-boxone">
                  {item?.user_id?.profile_photo[0] ? (
                    <div className="super-admin-suggestion-imageBoxOne enIMG33">
                      <Image
                        fluid
                        src={item?.user_id?.profile_photo[0]}
                        alt="Icon"
                        className="rounded-circle"
                      />
                    </div>
                  ) : (
                    <div className="super-admin-suggestion-imageBoxOne enIMG33">
                      <Image
                        fluid
                        src={require("../../../assets/images/ActionImages/demoprofile.jpg")}
                        alt="Icon"
                        className="rounded-circle"
                      />
                    </div>
                  )}
                </div> */}
              {/* <div className="super-admin-suggestion-imageBoxTwo ml-2"> */}
              <div className="f12-500">
                {item?.user_id?.first_name} {item?.user_id?.last_name}
              </div>
              {/* </div> */}
              {/* </div> */}
            </div>
            <div className="card-header-middle ml-2 f10-500">
              <div className="f12-500">
                {
                  PAYMENT_TYPE[
                  item?.expRequestId?.payment_data?.payment_method
                  ]
                }
              </div>
              {/* <div className="badge badge-warning p-2" style={{borderRadius:'1rem',color:'white'}}>{PAYMENT_STATUS[item?.expRequestId?.payment_status]}</div> */}
              {item?.expRequestId?.payment_status === 0 ? (
                <div
                  className="badge badge-warning p-2"
                  style={{ borderRadius: "1rem", color: "white" }}
                >
                  {PAYMENT_STATUS[item?.expRequestId?.payment_status]}
                </div>
              ) : null}
              {item?.expRequestId?.payment_status === 1 ? (
                <div
                  className="badge badge-success p-2"
                  style={{ borderRadius: "1rem", color: "white" }}
                >
                  {PAYMENT_STATUS[item?.expRequestId?.payment_status]}
                </div>
              ) : null}
              {item?.expRequestId?.payment_status === 2 ? (
                <div
                  className="badge badge-danger p-2"
                  style={{ borderRadius: "1rem", color: "white" }}
                >
                  {PAYMENT_STATUS[item?.expRequestId?.payment_status]}
                </div>
              ) : null}
              {item?.expRequestId?.payment_status === 3 ? (
                <div
                  className="badge badge-danger p-2"
                  style={{ borderRadius: "1rem", color: "white" }}
                >
                  {PAYMENT_STATUS[item?.expRequestId?.payment_status]}
                </div>
              ) : null}
              {item?.expRequestId?.payment_status === 4 ? (
                <div
                  className="badge badge-info p-2"
                  style={{ borderRadius: "1rem", color: "white" }}
                >
                  {PAYMENT_STATUS[item?.expRequestId?.payment_status]}
                </div>
              ) : null}
            </div>
            <div className="card-header-right f10-500 justify-content-center">
              <div className="f12-500">₹ {item?.amount}</div>
            </div>
          </div>{" "}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={props?.index + 1}>
          <Card.Body>
            {/******* Section One *********/}
            <hr className="mt-0" />
            <div className="row">
              <div className="col-4 sectionone-left">
                <p className="f10-700 pb-2 opacity5">
                  Event/ Event ID/ <br />
                  Event Type
                </p>

                <div className="f12-400">
                  <div className="f12-500">
                    {item?.expRequestId?.event_id?.name}
                  </div>
                  <div className="f10-400">
                    {item?.expRequestId?.event_id?._id}
                  </div>
                  <div className="f10-400">
                    {item?.expRequestId?.event_id?.isOnline
                      ? "Online"
                      : "Offline"}
                  </div>
                </div>
              </div>
              <div className="col-4 sectionone-middle ">
                <p className="f10-700 pb-2 opacity5">
                  Total PAX/
                  <br /> Ticket No.
                </p>
                <div className="f10-400">
                  {parseInt(item?.expRequestId?.kids_count) +
                    parseInt(item?.expRequestId?.adult_count)}
                </div>
              </div>
              <div className="col-4 sectionone-right ">
                <p className="f10-700 pb-2 opacity5">Date & Time</p>
                <div className="f10-400">
                  {moment(item?.createdAt).format("Do MMM YYYY")}
                  <br />
                  {moment(item?.createdAt).format("hh:mm A")}
                </div>
              </div>
            </div>
            {/******* Section Two *********/}
            {/* <hr className="mt-0" />
            <div className="row">
              <div className="col-4 sectionone-left"></div>
              <div className="col-5 sectionone-middle ">
                <p className="f10-700 pb-2 opacity5">Date & Time</p>
                <div className="f10-400">
                  {moment(item?.createdAt).format("Do MMM YYYY")}
                  <br />
                  {moment(item?.createdAt).format("hh:mm A")}
                </div>
              </div>
              <div className="col-3 sectionone-right "></div>
            </div> */}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </React.Fragment>
  );
};
